export enum MessageType {
  Error = 1,
  Info = 2,
  Inprogress = 3,
  Success = 4,
  Warning = 5
}